import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDoLglLy2PnPnOkwWil1axZ7TPrY3BsCfg",
  authDomain: "app.realtyflows.com",
  projectId: "realty-flows",
  storageBucket: "realty-flows.firebasestorage.app",
  messagingSenderId: "1069132129406",
  appId: "1:1069132129406:web:ba179ed216b6ee76b9e42f",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Force account selection every time
googleProvider.setCustomParameters({ prompt: "select_account" });
